import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    minHeight: "42px",
    height: "42px",
    flexShrink: 0,
    width: "fit-content",
    background: theme.palette.background.paper,
    "& .MuiTabs-flexContainer": {
      gap: 8,
    },
    "& .MuiTab-root": {
      minHeight: "42px",
      minWidth: "auto",
      padding: "0 16px",
      fontSize: "14px",
      fontWeight: 400,
      fontStyle: "normal",
      lineHeight: "21px",
      letterSpacing: "0.04em",
      textTransform: "none",
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
    },
    "& .Mui-selected": {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 600,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  yardTabs: {
    height: "42px",
    minHeight: "42px",
    maxHeight: "42px",
    opacity: 1,
    transform: "rotate(0deg)",
    flexShrink: 0,
    width: "fit-content",
    background: theme.palette.background.paper,
    "& .MuiTabs-scroller": {
      height: "42px",
    },
    "& .MuiTabs-flexContainer": {
      gap: 8,
      height: "42px",
    },
    "& .MuiTab-root": {
      minHeight: "42px",
      height: "42px",
      minWidth: "auto",
      padding: "0 16px",
      fontSize: "14px",
      fontWeight: 400,
      fontStyle: "normal",
      lineHeight: "21px",
      letterSpacing: "0.04em",
      textTransform: "none",
      opacity: 1,
      transform: "rotate(0deg)",
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
    },
    "& .Mui-selected": {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 600,
    },
    "& .MuiTabs-indicator": {
      height: "3px",
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  tabBadge: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${theme.palette.grey[400]} !important`,
    color: `${theme.palette.text.primary} !important`,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
    fontFamily: theme.typography.fontFamily,
  },
  tabBadgeActive: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.common.white} !important`,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
    fontFamily: theme.typography.fontFamily,
  },
}));
